var map = {
	".": 69,
	"./": 69,
	"./App": 57,
	"./App.css": 166,
	"./App.js": 57,
	"./App.test": 179,
	"./App.test.js": 179,
	"./Krmicon.png": 180,
	"./ScrollToTop": 181,
	"./ScrollToTop.js": 181,
	"./about": 95,
	"./about.js": 95,
	"./dadphoto.jpg": 122,
	"./home": 72,
	"./home.js": 72,
	"./images/carosel/carosel1.png": 174,
	"./images/carosel/carosel3.jpg": 175,
	"./images/carosel/carosel4.jpg": 176,
	"./images/cashew Types/AM.jpg": 429,
	"./images/cashew Types/BBP.jpg": 430,
	"./images/cashew Types/DJH.jpg": 431,
	"./images/cashew Types/DK.jpg": 432,
	"./images/cashew Types/JH.jpg": 433,
	"./images/cashew Types/K.jpg": 434,
	"./images/cashew Types/KK.jpg": 435,
	"./images/cashew Types/LWP.jpg": 436,
	"./images/cashew Types/W210.jpg": 437,
	"./images/cashew Types/W240.jpg": 438,
	"./images/cashew Types/W320.jpg": 439,
	"./images/cashew Types/W400.jpg": 440,
	"./images/cashew Types/Y240.jpg": 441,
	"./images/cashew Types/Y320.jpg": 442,
	"./images/cashew Types/YDW.jpg": 443,
	"./index": 69,
	"./index.css": 165,
	"./index.js": 69,
	"./json/cashewTypes": 59,
	"./json/cashewTypes.json": 59,
	"./locate": 96,
	"./locate.js": 96,
	"./logo.svg": 445,
	"./map": 97,
	"./map.js": 97,
	"./navbar": 94,
	"./navbar.js": 94,
	"./products": 98,
	"./products.js": 98,
	"./serviceWorker": 99,
	"./serviceWorker.js": 99,
	"./setupTests": 186,
	"./setupTests.js": 186
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 134;